import { NAMESPACE_GROUP } from '~/issues/constants';
import { initWorkItemsRoot } from '~/work_items';

initWorkItemsRoot({ workspaceType: NAMESPACE_GROUP });
